const Jobs = [
  {
    id: 1,
    slug: "management-representative-iso-as",
    title: "Management Representative - ISO & AS",
    department: "Quality",
    type: "Full-time",
    location: "Ernakulam, Kerala",
    experience: "5-6 years",
    salary: "₹50,000 - ₹60,000 per month",
    description:
      "Ensure compliance with international quality and aerospace standards such as ISO 9001 and AS9100. Maintain, monitor, and improve the organization's Quality Management System (QMS) and ensure continual compliance with customer, regulatory, and certification requirements.",
    requirements: [
      "B.E. / B.Tech in Mechanical Engineering or equivalent",
      "5-6 years of experience in quality management",
      "In-depth knowledge of ISO 9001 and AS9100 standards",
      "Certified Internal Auditor for ISO 9001 / AS9100 (preferred)",
      "Experience in mechanical component manufacturing, precision machining, or aerospace industry",
      "Strong experience in internal auditing and compliance documentation",
      "Good analytical, organizational, and communication skills",
      "Proficiency in MS Office and QMS-related software/tools",
    ],
    responsibilities: [
      "Implement and sustain QMS processes as per ISO and AS standards",
      "Review and update quality manuals, procedures, and work instructions",
      "Maintain documentation for all ISO/AS certifications and audits",
      "Plan and conduct internal audits across departments",
      "Track and monitor corrective and preventive actions (CAPA)",
      "Conduct training and awareness sessions on ISO/AS standards",
      "Prepare compliance reports for Management Review Meetings",
      "Identify risks and recommend process improvements",
    ],
  },
  {
    id: 2,
    slug: "business-development-manager",
    title: "Business Development Manager (BDM)",
    department: "Sales",
    type: "Full-time",
    location: "Ernakulam, Kerala",
    experience: "1+ years",
    description:
      "Drive business growth by identifying new opportunities, building relationships with clients, and developing strategic partnerships. Work closely with the sales and marketing teams to achieve revenue targets.",
    requirements: [
      "Bachelor's degree in Business, Marketing, or related field",
      "1+ years of experience in business development or sales",
      "Proven track record of meeting or exceeding sales targets",
      "Strong communication and negotiation skills",
      "Ability to build and maintain client relationships",
      "Experience in B2B sales preferred",
      "Self-motivated with excellent problem-solving abilities",
      "Proficiency in MS Office and CRM software",
    ],
    responsibilities: [
      "Identify and pursue new business opportunities",
      "Build and maintain relationships with potential clients",
      "Conduct market research to identify trends and opportunities",
      "Prepare and deliver sales presentations to clients",
      "Negotiate contracts and close deals",
      "Collaborate with marketing team on lead generation",
      "Meet and exceed monthly/quarterly sales targets",
      "Maintain accurate records of sales activities in CRM",
    ],
  },
];
export default Jobs;
